import { Hidden }                from "@material-ui/core";
import React, { FC }             from "react";
import { useSelector }           from "react-redux";
import { Loader }                from "semantic-ui-react";
import MenuType                  from "../../../domain/menu/MenuType";
import { ResKaState }            from "../../../index";
import GetAccountContainer       from "../../containers/GetAccountContainer";
import Header                    from "../../containers/HeaderContainer";
import Menu                      from "../../containers/MenuContainer";
import ContractPeriodInformation from "../common/ContractPeriodInformation";
import RightPositionSection      from "../common/layout/RightPositionSection";
import NotifyDisplay             from "../notify/NotifyDisplay";
import StaffInfo                 from "../staff/StaffInfo";
import "./BaseLayout.scss";

interface Props {
  menuType: MenuType;
  headerTitle: string;
}

const BaseLayout: FC<Props> = ({children, menuType, headerTitle}) => {
  const loading: boolean = useSelector((state: ResKaState) => state.fetchStatus.isFetching());
  return (
    <>
      <Menu menuType={ menuType }/>
      <Header headerTitle={ headerTitle }/>
      <ContractPeriodInformation/>
      <GetAccountContainer/>
      <NotifyDisplay/>
      <Loader active={ loading }/>
      <Hidden smDown={ true }>
        <main className="reska-base reska-base-md">
          <RightPositionSection>
            <StaffInfo/>
          </RightPositionSection>
          {
            children
          }
        </main>
      </Hidden>
      <Hidden mdUp={ true }>
        <main className="reska-base reska-base-sm">
          <RightPositionSection>
            <StaffInfo/>
          </RightPositionSection>
          {
            children
          }
        </main>
      </Hidden>
    </>
  );
}

export default BaseLayout;
